import React, { useState } from "react";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  updatePassword,
} from "firebase/auth";
import { useAuth } from "../AuthContext";

const Account = () => {
  const { user } = useAuth();
  const auth = getAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);
  const [showPasw, setShowPasw] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Fel e-post eller lösenord.");
    }
  };

  const handleCreateAccount = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await createUserWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Kunde inte skapa konto.");
    }
  };

  const handleResetPassword = () => {
    if (!email) {
      alert("Fyll i din e-post först.");
      return;
    }
    sendPasswordResetEmail(auth, email)
      .then(() => alert("Ett återställningsmail har skickats."))
      .catch(() => alert("Kunde inte skicka återställningsmail."));
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  const handleChangePassword = async () => {
    if (!newPassword) {
      alert("Skriv in ett nytt lösenord.");
      return;
    }
    try {
      await updatePassword(auth.currentUser, newPassword);
      alert("Lösenord uppdaterat.");
      setNewPassword("");
    } catch (err) {
      alert("Kunde inte uppdatera lösenord. Logga in igen?");
    }
  };

  return (
    <div className="loginWrapper">
      <h2>Konto</h2>

      {user ? (
        <>
          <p>
            Inloggad som: <strong>{user.email}</strong>
          </p>
          <button onClick={handleLogout}>Logga ut</button>
          {showPasw ? (
            <div style={{ marginTop: "2em" }}>
              <h4>Byt lösenord</h4>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nytt lösenord"
              />
              <button onClick={handleChangePassword}>Byt lösenord</button>
            </div>
          ) : null}
            <p style={{ marginTop: "1em" }}>
              <button
                onClick={() => setShowPasw(!showPasw)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#9c3d88ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  paddingTop: 20,
                  paddingLeft: 0,
                }}
              >
                {showPasw ? "Stäng" : "Ändra ditt lösenord"}
              </button>
            </p>
        </>
      ) : (
        <>
          <form onSubmit={creating ? handleCreateAccount : handleLogin}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-post"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Lösenord"
              required
            />
            <button type="submit">
              {creating ? "Skapa konto" : "Logga in"}
            </button>
          </form>

           <button
              onClick={handleResetPassword}
              style={{
                backgroundColor: "#35302bad",
                marginTop: "1em",
                width: "100%",
              }}
            >
              Skicka återställningsmail
            </button>

          {/* <p style={{ marginTop: "1em" }}>
            {creating ? "Har du redan ett konto?" : "Har du inget konto?"}{" "}
            <button
              onClick={() => setCreating(!creating)}
              style={{
                background: "none",
                border: "none",
                color: "#9c3d88ff",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {creating ? "Logga in här" : "Skapa konto"}
            </button>
          </p> */}

          {error && <p style={{ color: "red" }}>{error}</p>}
        </>
      )}
    </div>
  );
};

export default Account;
